// extracted by mini-css-extract-plugin
export var logo = "styles-module--logo--aee6e";
export var logos = "styles-module--logos--ffb55";
export var row = "styles-module--row--a017b";
export var text = "styles-module--text--5d3ef";
export var wrapper = "styles-module--wrapper--f329b";